<template>
	<div class="map-leaflet" ref="map-leaflet"></div>
</template>

<script>

  export default {
    props: {
		geoDetails: {
			type : [Array],
			required: false
		},
		zoom: {
			type: Number,
			required: false,
			default: 9
		},
		rounting: {
			type: Boolean,
			required: false,
			default: false
		}
    },
	data(){
		return {
			map:null,
			markers:[],
			polygons:[],
		}
	},
    computed: {

    },
    methods: {
		addMarker(model){
			let marker = window.L.marker([model.latitude,model.longitude]).addTo(this.map);
			marker.bindPopup("<b>"+model.title+"</b><br>"+model.details+"").openPopup();
			setTimeout(() => {
				marker.closePopup();
			}, 0);
		},
		addPolygon(model){
			let polygon = window.L.polygon(model.geoPoints).addTo(this.map);
			//polygon.bindPopup(model.title+"<br> <a href='google.com'></a>");
			let text = " "+model.title+" <br>"+model.details
			polygon.bindPopup(text);
		},
		setGeoDetailsRides(arr){
			arr.forEach(element => {
				try{
					let modelMarker = {
						latitude: element.pickup.geo.latitude,
						longitude: element.pickup.geo.longitude,
						title: "Pickup",
						details: element.pickup.title
					};
					this.addMarker(modelMarker);

					modelMarker = {
						latitude: element.dropoff.geo.latitude,
						longitude: element.dropoff.geo.longitude,
						title: "Dropoff",
						details: element.dropoff.title
					}
					this.addMarker(modelMarker);

					if (this.rounting === true) {
						window.L.Routing.control({
							waypoints: [
								window.L.latLng(element.pickup.geo.latitude, element.pickup.geo.longitude), // Punto A
								window.L.latLng(element.dropoff.geo.latitude, element.dropoff.geo.longitude)  // Punto B
							],
						})
						.on('routesfound', (e) => {
							const route = e.routes[0]; // Obtiene la primera ruta encontrada
							const bounds = window.L.latLngBounds(route.coordinates); // Crea los límites a partir de la ruta
							this.map.fitBounds(bounds); // Ajusta el zoom al camino completo
						})
						.addTo(this.map);
					}

					element.zonesNearest.forEach(_zone=>{
						let arrGeopoints= _zone.polygon.map((item)=>{
							return [parseFloat(item.latitude),parseFloat(item.longitude)];
						})
						let linkToRp ="<small> <a href='/rate-plans-edit?id="+(_zone.ratePlanId??0)+"' target='_blank'> Ir al rate plan </a></small>"
						let modelPoly ={
							geoPoints:arrGeopoints,
							title:"<b>Zone Name</b>: "+_zone.zoneName,
							details:"<b>Rate Plan</b>: "+_zone.ratePlanName+"<br>"+linkToRp
						}
						this.addPolygon(modelPoly)
					})
				}catch(err){
					console.log(err)
				}
			});
			setTimeout(() => {
				if (this.routing === false) {
					// si estamos trazando rutas en el mapa no seteamos zoom
					// fijo para evitar perder el zoom automatico
					this.map.setZoom(this.zoom);
				}
			}, 0);
		}
    },
	mounted(){
		this.map = window.L.map(this.$refs["map-leaflet"]).setView([51.505, -0.09], 13);
		window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		})
		.addTo(this.map);
		setTimeout(()=>{
            this.map.invalidateSize();
        }, 10);

		if(!this.$root.isEmpty(this.geoDetails)){
			this.setGeoDetailsRides([...this.geoDetails])
		}
	}

  }
</script>

<style>
	.map-leaflet { height: 500px; }
</style>
